<ng-container [formGroup]="form">
  <p-autoComplete
    [disabled]="disabled"
    placeholder="Selecione"
    [id]="id || name"
    class="custom-auto-complete"
    [formControlName]="name"
    [delay]="900"
    [dataKey]="key"
    [suggestions]="optionsForAutocomplete"
    [forceSelection]="true"
    (completeMethod)="getOptions($event); onSearch.emit($event)"
    [field]="fieldName"
    [dropdown]="true"
    [emptyMessage]="'Nenhum resultado encontrado'"
    minLength="1"
    (onSelect)="onChange.emit($event)"
    [ngClass]="customClass"
    (focusout)="onFocusOut.emit($event)"
    (onKeyUp)="onKeyUp($event)"
  >
  </p-autoComplete>
</ng-container>
